import { useSelector } from 'react-redux';

export default () => {
  const { userDetails } = useSelector(state => state.auth);

  const userRoles = userDetails
    ? userDetails?.authorities?.map(({ authority }) => authority)
    : [];
  const userHasRole = role => userRoles.includes(role);

  const isMainUser = userHasRole('ROLE_MAIN_USER');
  const isReporter = userHasRole('ROLE_REPORTER');
  const isBlackBoxUploader = userHasRole('ROLE_BLACK_BOX');
  const hasNoRoles = userRoles.length === 0;

  return {
    userRoles,
    userHasRole,
    isMainUser,
    isReporter,
    isBlackBoxUploader,
    hasNoRoles,
  };
};
